import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { togglePricingPlanUpgrade } from '../../../redux/main/main.actions';

import { selectIsCanvasModalPricingPlanLimitEnabled, selectCanvasModalPricingPlanLimitType } from '../../../redux/diagram/diagram.selectors';
import { disableCanvasPricingPlanLimit } from '../../../redux/diagram/diagram.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalPricingPlanLimitCanvas.scss';

const mapTypesAmounts = {
    diagrams: 3,
    tables: 40,
    columns: 20,
    notes: 20,
    pens: 100,
    areas: 10,
}
const mapTypesValues = {
    diagrams: 'diagrams',
    tables: 'tables',
    columns: 'columns / table',
    notes: 'notes',
    pens: 'draws',
    areas: 'areas',
}

export const ModalPricingPlanLimitCanvas = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsCanvasModalPricingPlanLimitEnabled);
    const modalType = useSelector(selectCanvasModalPricingPlanLimitType);

    const [type, setType] = useState('');

    useEffect(() => {
        if (!modalType) return;
        setType(modalType);
        return () => { };
    }, [modalType]);

    const handleSave = () => {
        trackEvent('app_modal_pricing_limit_canvas_submit', {
            page: 'app',
            type: 'modals',
            subtype: type,
        });
        dispatch(disableCanvasPricingPlanLimit(null));
        dispatch(togglePricingPlanUpgrade('canvas'));
        setTimeout(() => {
            setType('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(disableCanvasPricingPlanLimit(null));
        setTimeout(() => {
            setType('');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-pricing-limit-canvas ${type}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`You're growing fast! 🚀`}</div>
            <div className="modal-content-body">
                <div className='description-text'>
                    {/* You’ve hit the cap for free diagrams.< br /> */}
                    You’ve hit the cap for {mapTypesAmounts[type]} free {mapTypesValues[type]}.< br />
                    Upgrade to keep building without limits.
                </div>
                <button onClick={() => handleSave()}>Upgrade</button>
            </div>
        </Modal>
    );
};

export default ModalPricingPlanLimitCanvas;



// You’ve reached your free plan limit.
// You’ve reached the limit of three free diagrams.
// Upgrade to create unlimited diagrams.

// You're growing fast! 🚀
// You’ve reached the limit of 3 free diagrams.
// Upgrade to keep building without limits.

// [Upgrade Plan]





// two goods choises

// You're growing fast! 🚀
// You’ve used up all your free diagrams.
// Upgrade to keep the momentum going.



// You're growing fast! 🚀
// You’ve hit the cap for free diagrams.
// Upgrade to keep building without limits.
